import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler
);

const ExpenseChart = ({ data }) => {

  // 🔥 SAFE FIX
  if (!data || !data.labels || !data.datasets) {
    return <div className="card p-3">Loading chart...</div>;
  }

  const safeData = {
    labels: data.labels,
    datasets: [
      {
        data: data.datasets[0].data,
        borderColor: "#facc15",
        backgroundColor: "rgba(250,204,21,0.3)",
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },

      // 🔥 Tooltip → 5k format
      tooltip: {
        callbacks: {
          label: function(context) {
            let value = context.raw;
            if (value >= 1000) {
              return (value / 1000).toFixed(0) + "k";
            }
            return value;
          }
        }
      }
    },

    scales: {
      y: {
        beginAtZero: true,
        grid: { color: "#eee" },

        // 🔥 Y-axis → 5k format
        ticks: {
          callback: function(value) {
            if (value >= 1000) {
              return (value / 1000).toFixed(0) + "k";
            }
            return value;
          }
        }
      },

      x: {
        grid: { display: false },
      },
    },
  };

  return (
    <div className="card border-0 shadow-sm h-100 p-3">

      <div className="d-flex justify-content-between mb-3">
        <h6 className="fw-semibold">Expense</h6>

        <select className="form-select form-select-sm w-auto">
          <option>Office Management App</option>
        </select>
      </div>

      <div style={{ height: "290px" }}>
        <Line data={safeData} options={options} />
      </div>

    </div>
  );
};

export default ExpenseChart;